<div
  class="empty-search-content"
  *ngIf="
    (advancedSearchService.systemCount$ | async) === -1 &&
    (advancedSearchService.isSystemLoading$ | async) === false
  "
>
  <sh-icon icon="filter-search" size="l" disabled></sh-icon>
  <sh-text size="body-1">
    <div style="white-space: pre-line">
      {{ 'message.startAdvancedSearch' | translate }}
    </div>
  </sh-text>
</div>

<sh-card
  class="advanced-search-content"
  *ngIf="
    (advancedSearchService.systemCount$ | async) !== -1 ||
    (advancedSearchService.isSystemLoading$ | async) === true
  "
>
  <sh-spinner
    *ngIf="(advancedSearchService.isSystemLoading$ | async) === true"
  ></sh-spinner>

  <div
    class="empty-search-content"
    *ngIf="
      (advancedSearchService.systemCount$ | async) === 0 &&
      (advancedSearchService.isSystemLoading$ | async) === false
    "
  >
    <sh-icon icon="search" size="l" disabled></sh-icon>
    <sh-text size="body-1">
      <div
        style="white-space: pre-line"
        [innerHTML]="'message.noSystemInAdvanceSearch' | translate"
      ></div>
    </sh-text>
  </div>

  <ng-container
    *ngIf="
      ((advancedSearchService.systemCount$ | async) ?? 0) > 0 &&
      (advancedSearchService.isSystemLoading$ | async) === false
    "
  >
    <div slot="header" class="content-header">
      <sh-text color="secondary">
        {{
          ((advancedSearchService.systemCount$ | async) ?? 0) > 500
            ? ' > 500 '
            : (advancedSearchService.systemCount$ | async) + ' '
        }}{{
          ((advancedSearchService.systemCount$ | async) ?? 0) > 1
            ? 'Systems'
            : 'System'
        }}
      </sh-text>
      @if (((advancedSearchService.systemCount$ | async) ?? 0) >= 500) {
        <sh-icon
          icon="information"
          size="s"
          id="advance-search-result-info"
          class="advance-search-result-info-icon"
        >
        </sh-icon>
        <sh-tooltip
          [innerHTML]="'label.advanceSearchResultInfoIcon.tooltip' | translate"
          target="advance-search-result-info"
          placement="top"
          variation="long"
          class="advance-search-result-info-icon-message"
        ></sh-tooltip>
      }
    </div>

    <div class="table-wrapper">
      <table
        mat-table
        [dataSource]="dataSource"
        matSort
        [trackBy]="trackBySerialNumber"
        class="mat-elevation-z8"
        role="table"
        aria-label="Advanced search results"
      >
        <!-- Serial Number Column -->
        <ng-container matColumnDef="serialNumber">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            sortActionDescription="Sort by serial number"
            scope="col"
          >
            <sh-text size="title-1">
              {{ 'label.serialNumber' | translate }}
            </sh-text>
            <span
              class="custom-sort-icon"
              [ngClass]="getSortDirection('serialNumber')"
              aria-hidden="true"
            >
              <span class="arrow up"></span>
              <span class="arrow down"></span>
            </span>
          </th>
          <td mat-cell *matCellDef="let element" class="serial-number-cell">
            <div class="serial-number-content">
              <a
                [href]="getSystemUrl(element)"
                target="_blank"
                rel="noopener noreferrer"
                class="system-link"
                (click)="onSystemLinkClick(element)"
                [attr.aria-label]="
                  'Open system ' + element.serialNumber + ' in new tab'
                "
              >
                <sh-text size="body-1">{{ element.serialNumber }}</sh-text>
                <sh-icon icon="open-link" size="xs" button></sh-icon>
              </a>
            </div>
          </td>
        </ng-container>

        <!-- Dynamic columns generation -->
        <ng-container
          *ngFor="
            let column of tableColumns.slice(1);
            trackBy: trackByColumnKey
          "
          [matColumnDef]="column.key"
        >
          <th
            mat-header-cell
            *matHeaderCellDef
            [mat-sort-header]="column.sortable ? column.key : null"
            [sortActionDescription]="
              'Sort by ' + (column.translationKey | translate)
            "
            scope="col"
            [class]="column.key + '-header'"
          >
            <sh-text size="title-1">
              {{ column.translationKey | translate }}
            </sh-text>
            <span
              *ngIf="column.sortable"
              class="custom-sort-icon"
              [ngClass]="getSortDirection(column.key)"
              aria-hidden="true"
            >
              <span class="arrow up"></span>
              <span class="arrow down"></span>
            </span>
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            [class]="column.key + '-cell'"
            [attr.data-label]="column.translationKey | translate"
          >
            <sh-text size="body-1">
              {{
                column.key === 'isSupported'
                  ? (element[column.key] | translate)
                  : element[column.key]
              }}
            </sh-text>
          </td>
        </ng-container>

        <tr
          mat-header-row
          *matHeaderRowDef="displayedColumns; sticky: true"
        ></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns"
          [attr.aria-label]="'System row for ' + row.serialNumber"
        ></tr>
      </table>
    </div>
  </ng-container>
</sh-card>
